(function () {
  "use strict";

  // Ao clicar em um plano antes do cadastro
  $(".btn-plano-cad").on("click", function (ev) {
    ev.preventDefault();
    const planoId = $(this).data("plano");
    $("#cd-plano").val(planoId);
    $("#cadastro_retorno").val(
      url_base +
        "cliente/anuncio/cadastrar/plano/" +
        planoId +
        "/cad-success"
    );
    openModal("modal-cadastro");
  });
})();
